import React from 'react'
import ContentBlockMain from '../components/ContentBlocks/ContentBlockMain'
import Hero from '../components/Heros/Hero'
import TitleBlock from '../components/ContentBlocks/TitleBlock'
import ContentBoxes from '../components/ContentBlocks/ContentBoxes'
import ContentBlockCenter from '../components/ContentBlocks/ContentBlockCenter'
import SideBySide from '../components/ContentBlocks/SideBySide'
import Shout from '../components/Shout/Shout'

const IndexPage = () => {
  return (
    <main>
      <Hero storyId={'a-art-PLdX818CTRSt8j6U1iHNrg'} logoHidden={false} />
      <Shout />
      {/* <TitleBlock
        storyId={'a-art-uvy63BwTQUeot8uxTfjh0Q'}
        sx={styles.titleBlock}
      /> */}

      {/* ! about */}
      <ContentBlockCenter storyId={'a-art-U07PjZmgRDGHp0PtwGDX2g'} />

      {/* ! Menu */}
      <ContentBlockMain storyId={'a-art-b57nFeDKQ1mguT-jDAHSww'} />

      {/* Food Carousel  */}

      <ContentBlockCenter storyId={'a-art-f4qrZNgGR7_MHSY1x18ZYw'} />

      {/* Events  */}

      <SideBySide storyId={'a-art--LtTVHMCTIO2wf97VF9QLA'} />

      {/* Private Dining  */}

      <SideBySide storyId={'a-art-fYQldVfFT1KXUwRlIrCFRA'} flipSides={true} />

      {/* Gallery  */}

      <ContentBlockMain storyId={'a-art-PJ5y_wkSSsuaXgoUfD65ag'} sx={styles.ContentBlockMain2} />

      {/* Wine Room  */}

      <SideBySide storyId={'a-art-StPWbmCZRxavvr7Csp6bEg'} />

      {/* Drinks carousel Images */}

      <ContentBlockCenter storyId={'a-art-EQ7usb0oSZKV9guSAwsoeg'} />

      {/* Contact us */}

      <SideBySide storyId={'a-art-66UGA9qoSTOm_5TDorH8Ug'} />

      {/* Find Us */}

      <ContentBlockCenter storyId={'a-art-_b4Wy3jfRPS9SzJPzEeSyA'} />

      {/* <ContentBoxes
        storyIds={[
          'a-art-Z8cD90WSQeaGd79EZRRigw',
          'a-art-vpx7mUHeQOGQ3mf03ofIAQ',
          'a-art-zll6wDURSn28jmJMxPwESg',
          'a-art-JDEp1ak_R3ixcm8UgYvyxw',
        ]}
        sx={styles.contentBoxes}
      /> */}
    </main>
  )
}

export default IndexPage

const styles = {
  titleBlock: {
    padding: ['3rem 1rem', '', '4rem 2rem 4rem 6rem'],
    '.title': {
      fontSize: ['2rem', '2.5rem', '3rem']
    }
  },

  titleBlock2: {
    padding: ['3rem 1rem', '', '4rem 2rem 5rem 6rem'],
    '.title': {
      fontSize: ['2rem', '2.5rem', '3rem']
    }
  },
  contentBoxes: {
    marginBottom: '3rem'
  },

  ContentBlockMain2: {
    // gridTemplateRows: 'repeat(2, 1fr)',
    // '.imageContainer1': {
    //   height: '100%',
    // },
    // '.imageContainer1': {
    //   height: '100%',
    // },
    // '.imageContainer3': {
    //   gridColumnStart: '1',
    //   gridColumnEnd: '3',
    //   gridRowStart: '2',
    //   gridRowEnd: '5',
    // },
    // '.content': {
    //   // backgroundColor: '#fef1f1',
    //   padding: ['1rem', '', '5rem 3rem'],
    //   gridColumnStart: '3',
    //   gridColumnEnd: '6',
    //   gridRowStart: '2',
    //   gridRowEnd: '5',
    // },
  }
}
